import { render, staticRenderFns } from "./MainFeatures.vue?vue&type=template&id=1f65b0c4&scoped=true&"
import script from "./MainFeatures.vue?vue&type=script&lang=js&"
export * from "./MainFeatures.vue?vue&type=script&lang=js&"
import style0 from "./MainFeatures.vue?vue&type=style&index=0&id=1f65b0c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f65b0c4",
  null
  
)

export default component.exports